import { render, staticRenderFns } from "./AppDrag.vue?vue&type=template&id=b94b286c&scoped=true&"
import script from "./AppDrag.vue?vue&type=script&lang=js&"
export * from "./AppDrag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b94b286c",
  null
  
)

export default component.exports